<template>
  <table class="login-table">
    <tr>
      <td>
        <a :href="`http://souke.xdf.cn/Teacher/${$store.state.soukecityId}.html?CategoryCode=15`">
          <div class="icon">
            <i style="background-position: 3px 6px"></i>
          </div>
          <div class="title">教师查询</div>
        </a>
      </td>
      <td>
        <a href="http://souke.xdf.cn/Campus/0.html">
          <div class="icon">
            <i style="background-position: 6px -56px"></i>
          </div>
          <div class="title">校区查询</div>
        </a>
      </td>
      <td>
        <a href="http://souke.xdf.cn/">
          <div class="icon">
            <i style="background-position: -169px 0"></i>
          </div>
          <div class="title">快捷报班</div>
        </a>
      </td>
    </tr>
    <tr>
      <td>
        <a href="http://zhongkao.xdf.cn/list_1000_1.html">
          <div class="icon">
            <i style="background-position: -52px 2px"></i>
          </div>
          <div class="title">中考资料</div>
        </a>
      </td>
      <td>
        <a href="http://gaokao.xdf.cn/list_1019_1.html">
          <div class="icon">
            <i style="background-position: -108px 2px"></i>
          </div>
          <div class="title">高考资料</div>
        </a>
      </td>
      <td>
        <a href="http://www.xdf.cn/zhuanti/kaoshiyueli.html">
          <div class="icon">
            <i style="background-position: -229px 4px"></i>
          </div>
          <div class="title">考试月历</div>
        </a>
      </td>
    </tr>
    <tr>
      <td>
        <a href="http://souke.xdf.cn/">
          <div class="icon">
            <i style="background-position: -303px 2px"></i>
          </div>
          <div class="title">热报</div>
        </a>
      </td>
      <td>
        <a href="http://gaokao.xdf.cn/college/">
          <div class="icon">
            <i style="background-position: -53px -57px"></i>
          </div>
          <div class="title">院校库</div>
        </a>
      </td>
      <td>
        <a href="http://www.xdf.cn/toutiao/">
          <div class="icon">
            <i style="background: url(http://file.xdf.cn/neworiental/images/icons.png) no-repeat  -4px -258px;"></i>
          </div>
          <div class="title">教育头条</div>
        </a>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'Logintable'
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.login-table
  height: 335px
  width: 100%
  display: flex
  flex-direction: column
  border-top: 1px solid #eee
  border-left: 1px solid #eee
  border-collapse: collapse
  tr
    flex: 1
    display: flex
    td
      flex: 1
      display: flex
      height: 111px
      flex-direction: column
      border-right: 1px solid #eee
      border-bottom: 1px solid #eee
      a
        display: flex
        flex-direction: column
        height: 100%
        width: 100%
        color: #666
        .icon
          flex: 2
          position: relative
          i
            position: absolute
            display: block
            width: 40px
            height: 40px
            top: 50%
            left: 50%
            margin-left: -20px
            margin-top: -12px
            background: url(http://images.xdf.cn/school/middleschool/static/images/sprite.png) no-repeat
        .title
          flex: 1
          text-align: center
      &:hover
        .title
          color: $themeColor
      .icon
        flex: 2
        position: relative
        i
          position: absolute
          display: block
          width: 40px
          height: 40px
          top: 50%
          left: 50%
          margin-left: -20px
          margin-top: -20px
          background: url(http://images.xdf.cn/school/middleschool/static/images/sprite.png) no-repeat
        .title
          flex: 1
          color: #666
          text-align: center
          a
            display: inline
            &:hover
              color: #31a893
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/components/Logintable.vue